import "focus-visible";

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// IE doesn't support console.table
if (console.table === undefined) {
  console.table = console.log;
}
